/**
 * Purchase-desk staff: may record a return against an unload and open the
 * purchase order behind a row. Mirrors PURCHASE_RETURN_ROLES on the server.
 */
export const PURCHASE_DESK_ROLES = [
  'Master Admin',
  'Production Admin',
  'Purchase Department',
  'Accountant Assistant',
];

/** Complete Unloading (All Steps) is a purchase-desk screen: same roles as PD Approval. */
export const MASTER_UNLOAD_ROLES = [
  'Production Admin',
  'Master Admin',
  'Purchase Department',
];

export const canCompleteUnloadAllSteps = (role?: string) =>
  MASTER_UNLOAD_ROLES.includes(role || '');

/** Who may raise or change a purchase order. */
export const PURCHASE_ORDER_EDIT_ROLES = [
  'Master Admin',
  'Production Admin',
  'Purchase Department',
];

/** Deleting takes the All Purchase row and the PDF with it, so it stays with the admins. */
export const PURCHASE_ORDER_DELETE_ROLES = ['Master Admin', 'Production Admin'];

export const canManagePurchase = (role?: string) =>
  PURCHASE_DESK_ROLES.includes(role || '');

export const canEditPurchaseOrder = (role?: string) =>
  PURCHASE_ORDER_EDIT_ROLES.includes(role || '');

export const canDeletePurchaseOrder = (role?: string) =>
  PURCHASE_ORDER_DELETE_ROLES.includes(role || '');

/** Master Admin and Production Admin may edit or delete listing records they can add. */
export const LIST_EDIT_DELETE_ROLES = ['Master Admin', 'Production Admin'];

export const canEditDeleteListRecord = (role?: string) =>
  LIST_EDIT_DELETE_ROLES.includes(role || '');
